import ChartWrapper from './ChartWrapper';
import { ChartWrapperProps } from './ChartWrapper.types';

function LineChart({
  height = 300,
  width = '100%',
  options,
  series,
  ...rest
}: ChartWrapperProps) {
  return (
    <ChartWrapper
      height={height}
      type="line"
      width={width}
      options={options}
      series={series}
      {...rest}
    />
  );
}
export default LineChart;
